import { FC } from 'react';
import { Button, TextField } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { CustomSelectFormik } from 'components/elements';
import { IOption } from 'components/elements/CustomSelect';
import { useAppSelector } from 'store/hooks';
import { IStreetFormValues } from 'types';
import { getStreetTypeOptionsSelector } from 'store/streets-types';
import { CityAutocompleteField } from '../CityAutocompleteField';
import s from './index.module.scss';

interface StreetFormProps {
	buttonText: string;
	cityOptions: IOption[];
	cityOptionsLoading: boolean;
	hasMoreCityOptions: boolean;
	initialCityTitle?: string;
	initialValues: IStreetFormValues;
	onCityLoadMore: () => void;
	onCitySearch: (search: string) => void;
	onSubmit: (values: IStreetFormValues) => void;
}

export const StreetForm: FC<StreetFormProps> = ({
	buttonText,
	cityOptions,
	cityOptionsLoading,
	hasMoreCityOptions,
	initialCityTitle = '',
	initialValues,
	onCityLoadMore,
	onCitySearch,
	onSubmit,
}) => {
	const streetTypeOptions = useAppSelector(getStreetTypeOptionsSelector);

	return (
		<Formik initialValues={initialValues} onSubmit={onSubmit}>
			{({ values, dirty, setFieldValue }) => {
				const isSubmitDisabled = !values.name.trim() || !values.streetTypeId || !values.cityId || !dirty;

				return (
					<Form className={s.form}>
						<Field label="Назва вулиці" name="name" variant="outlined" as={TextField} fullWidth />
						<Field label="Тип вулиці" name="streetTypeId" options={streetTypeOptions} component={CustomSelectFormik} />
						<CityAutocompleteField
							cityOptions={cityOptions}
							cityOptionsLoading={cityOptionsLoading}
							hasMoreCityOptions={hasMoreCityOptions}
							initialCityTitle={initialCityTitle}
							onCityLoadMore={onCityLoadMore}
							onCitySearch={onCitySearch}
							onChange={(cityId) => setFieldValue('cityId', cityId)}
							value={`${values.cityId || ''}`}
						/>

						<Button className={s.button} type="submit" disabled={isSubmitDisabled} variant="rounded">
							{buttonText}
						</Button>
					</Form>
				);
			}}
		</Formik>
	);
};
